import { FnSelectModel } from './../fn-select.model';
import {
    Component,
    forwardRef,
    ViewEncapsulation,
    Input,
    ElementRef,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

/**
 * This component is used to create Single Select.
 * To use this component import FnSelectModule in Module.
 */
@Component({
    selector: 'fn-select',
    templateUrl: 'fn-select.component.html',
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FnSelectComponent),
            multi: true,
        },
    ],
})
export class FnSelectComponent extends FnSelectModel {
    /**
     * Input member variable
     * custom property for selected value.
     */
    @Input() inputKey = '';
    /**
     * Creates an instance of fn select component.
     */
    constructor(elementRef: ElementRef) {
        super(elementRef);
    }
}
